import styled from "styled-components";
import {Card} from "antd";

export const StyledCustomerDashboardProductCard = styled(Card)`
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  /* box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05); */
  border-radius: 5px;

  .ant-card-body {
    padding: 8px 1.6rem;
  }
  .ant-card-head {
    padding: 0 1.6rem;
    .ant-card-head-title {
      font-weight: 600;
    }
  }
`;

export const StyledCustomerDashboardProductCardContent = styled.div`
  display: grid;
  gap: 1.5rem;
  .product-card-image-wrapper {
    width: 100%;
    height: 18.5rem;
    border-radius: 5px;
    .product-card-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 5px;
    }
  }
  .product-card-info-text {
    font-weight: 400;
    font-size: 1.4rem;
    overflow: hidden;
    display: -webkit-box;
    /* display 4 lines only */
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
  }
  .product-card-extra-info {
    font-weight: 600;
    font-size: 1.6rem;
  }
  @media (min-width: 670px) {
    grid-template-columns: 32rem auto auto;
    grid-template-rows: auto;

    .product-card-image-wrapper {
      grid-column: 1/2;
      grid-row: 1/4;
      // height: 16rem;
      .product-card-image {
        height: 100%;
      }
    }
    .product-card-info-text {
      grid-column: 2/4;
      grid-row: 1/2;
    }
    .product-card-extra-info {
      grid-column: 2/4;
    }
    .product-card-start-btn {
      grid-column: 2/3;
      grid-row: 3/4;
    }
    .product-card-details-btn {
      grid-column: 3/4;
      grid-row: 3/4;
    }
  }
`;

export const StyledCustomerProductCardViewDetailsCreatedBy = styled.div`
  .host-heading-text {
    font-weight: 600;
    font-size: 1.4rem;
    color: #1c1726;
  }
  .host-info-wrapper {
    margin-top: 1.6rem;
    display: grid;
    grid-template-columns: 5rem auto;
    grid-template-rows: auto;

    align-items: center;
    gap: 2.4rem;
    .host-avatar-wrapper {
      grid-column: 1/2;
    }
    .host-name-info-wrapper {
      .host-name {
        font-weight: 600;
        font-size: 1.4rem;
        color: #1c1726;
        word-break: break-word;
      }
      .host-role {
        font-size: 1.4rem;
        color: #1c1726;
        /* word-break: break-word; */
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  }
  /* @media (max-width: 425px) {
    // padding: 2rem 3rem;
    .host-info-wrapper {
      display: flex;
      flex-direction: column;
      align-items: initial;
      gap: 1.6rem;
    }
  } */
`;
